import React from "react";
import { db } from "../firebase";
import { deleteDoc, doc } from "firebase/firestore";

const useDeleteProduct = (id) => {
  const deleteUser = async (id) => {
    const userDoc = doc(db, "products", id);
    await deleteDoc(userDoc);
  };

  deleteUser(id);
};

export default useDeleteProduct;
